import { render } from "./AllBusinessPartnerRequests.vue?vue&type=template&id=e4d85448&scoped=true"
import script from "./AllBusinessPartnerRequests.vue?vue&type=script&lang=js"
export * from "./AllBusinessPartnerRequests.vue?vue&type=script&lang=js"

import "./AllBusinessPartnerRequests.vue?vue&type=style&index=0&id=e4d85448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4d85448"]])

export default __exports__